module.exports = __webpack_public_path__ + "static/media/logo_harinera_anahuac.9270785e.jpg";